import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

// Your component
const MapComponent = ({address}) => {

  return (
    // <LoadScript
    //   googleMapsApiKey="AIzaSyAsIbU83moc8MIocD2dkhaCU90GAoGSspU&q=" // Replace with your Google Maps API Key
    // >
    //   <GoogleMap
    //     mapContainerStyle={mapStyles}
    //     zoom={13}
    //     center={center}
    //   >
    //     <Marker position={center} />
    //   </GoogleMap>
    // </LoadScript>
    <iframe
      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAsIbU83moc8MIocD2dkhaCU90GAoGSspU&q=${address}`}
      width="100%"
      height="380"
      className='rounded-xl'
      allowfullscreen=""
      loading="lazy"
      title={address}
    ></iframe>
  )
}

export default MapComponent;
